export function getFixedResponsePrices<
  T extends object,
  K extends { [P in keyof T]: T[P] extends number | null | undefined ? P : never }[keyof T],
>({
  digits,
  data,
  keys,
  additionalDivider,
}: {
  digits: number;
  data: T;
  keys: K[];
  additionalDivider?: number;
}) {
  const newPrices = {} as Record<K, number>;
  keys.forEach((key) => {
    newPrices[key] = fixResponsePrice({
      digits,
      price: data[key] as number | null | undefined,
      additionalDivider,
    });
  });

  return newPrices;
}

export function fixResponsePrice({
  digits,
  price,
  additionalDivider = 1,
}: {
  digits: number;
  price: number | null | undefined;
  additionalDivider?: number;
}) {
  const powed = Math.pow(10, digits);

  try {
    return (price || 0) / powed / additionalDivider;
  } catch (e) {
    return 0;
  }
}
